var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 217.167,
    height: 286.49,
    viewBox: "0 0 217.167 286.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5146",
    "data-name": "Group 5146",
    transform: "translate(-14742.659 -20989.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-2",
    transform: "translate(14806.416 20989.746)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 109.082,
    height: 82.622,
    transform: "translate(0.1 51.709)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14872",
    "data-name": "Path 14872",
    d: "M313.132,197.861v-5.91c0-3.853,0-9.5-.04-16.7,0-14.4-.04-35.038-.073-60.008l.146.14H204.09l.173-.173v82.622l-.153-.16,78.742.08,22.354.04h.087l-22.314.04-78.848.08h-.16V114.96h109.4v.146c-.033,25-.053,45.673-.073,60.094,0,7.194,0,12.831-.04,16.637v4.372C313.132,197.362,313.132,197.861,313.132,197.861Z",
    transform: "translate(-203.97 -63.53)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4792",
    "data-name": "Rectangle 4792",
    width: 7.367,
    height: 19.925,
    transform: "translate(32.277 90.408)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4793",
    "data-name": "Rectangle 4793",
    width: 7.367,
    height: 19.925,
    transform: "translate(63.535 90.408)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4794",
    "data-name": "Rectangle 4794",
    width: 7.367,
    height: 31.624,
    transform: "translate(73.957 78.708)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4795",
    "data-name": "Rectangle 4795",
    width: 7.367,
    height: 6.702,
    transform: "translate(22.747 104.064)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4796",
    "data-name": "Rectangle 4796",
    width: 7.367,
    height: 10.927,
    transform: "translate(42.698 99.405)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4797",
    "data-name": "Rectangle 4797",
    width: 7.367,
    height: 13.436,
    transform: "translate(53.12 96.896)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_227",
    "data-name": "Ellipse 227",
    cx: 1.584,
    cy: 1.584,
    r: 1.584,
    transform: "translate(26.547 81.264)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14873",
    "data-name": "Path 14873",
    d: "M282.843,121.49c.093,0,.173,7.274.173,16.245s-.08,16.245-.173,16.245-.173-7.274-.173-16.245S282.743,121.49,282.843,121.49Z",
    transform: "translate(-230.295 -65.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14874",
    "data-name": "Path 14874",
    d: "M344.46,139.252a7.854,7.854,0,0,1-1.145.067l-3.135.053c-2.662.033-6.3.053-10.335.053h-5.69a6.961,6.961,0,0,0-1.251.04,2.542,2.542,0,0,0-1.038.439,2.722,2.722,0,0,0-1.091,1.69,5.326,5.326,0,0,0-.053.918v2.176a6.944,6.944,0,0,1-.067,1.151,8.019,8.019,0,0,1-.067-1.151v-2.176a5.263,5.263,0,0,1,0-.958,2.935,2.935,0,0,1,1.165-1.883,2.822,2.822,0,0,1,1.151-.506,7.167,7.167,0,0,1,1.331-.06h5.69c4.033,0,7.686,0,10.335.047l3.134.06A6.808,6.808,0,0,1,344.46,139.252Z",
    transform: "translate(-242.972 -71.604)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14875",
    "data-name": "Path 14875",
    d: "M302.15,152.8a.992.992,0,0,1-.18-.047l-.512-.18c-.226-.08-.5-.193-.839-.3l-1.158-.333a21.662,21.662,0,0,0-18.115,3.52,35.272,35.272,0,0,0-4.832,4.658,18.71,18.71,0,0,1-5.65,4.592,8.439,8.439,0,0,1-3.654.759,10.714,10.714,0,0,1-3.54-.745,30.9,30.9,0,0,1-5.89-3.367,30.179,30.179,0,0,0-5.324-2.888,11.88,11.88,0,0,0-5.171-.825,17.529,17.529,0,0,0-7.32,2.063,15.639,15.639,0,0,0-1.764,1.111l-.439.333a.666.666,0,0,1-.153.1,10.7,10.7,0,0,1,2.289-1.664,17.3,17.3,0,0,1,7.387-2.189,11.979,11.979,0,0,1,5.284.805,29.621,29.621,0,0,1,5.424,2.888,31.278,31.278,0,0,0,5.836,3.327,10.515,10.515,0,0,0,3.434.725,8.265,8.265,0,0,0,3.5-.732A18.3,18.3,0,0,0,276.3,159.9a35.975,35.975,0,0,1,4.891-4.7,21.689,21.689,0,0,1,10.648-4.04,21.21,21.21,0,0,1,7.686.666l1.158.366c.333.113.606.24.832.326l.5.213C302.1,152.764,302.157,152.791,302.15,152.8Z",
    transform: "translate(-215.223 -75.606)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 1.584,
    cy: 1.584,
    r: 1.584,
    transform: "translate(50.964 87.766)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_229",
    "data-name": "Ellipse 229",
    cx: 1.584,
    cy: 1.584,
    r: 1.584,
    transform: "translate(76.246 73.977)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14876",
    "data-name": "Path 14876",
    d: "M245.484,207.953a40.005,40.005,0,0,1-7.434,0,40.009,40.009,0,0,1,7.434,0Z",
    transform: "translate(-215.37 -94.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14877",
    "data-name": "Path 14877",
    d: "M260.01,207.953a40.08,40.08,0,0,1-7.44,0,40.08,40.08,0,0,1,7.44,0Z",
    transform: "translate(-220.227 -94.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14878",
    "data-name": "Path 14878",
    d: "M276.2,207.953a40.077,40.077,0,0,1-7.44,0,40.08,40.08,0,0,1,7.44,0Z",
    transform: "translate(-225.642 -94.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14879",
    "data-name": "Path 14879",
    d: "M291.64,207.963a40.077,40.077,0,0,1-7.44,0,40.074,40.074,0,0,1,7.44,0Z",
    transform: "translate(-230.807 -94.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14880",
    "data-name": "Path 14880",
    d: "M306.69,207.963a40.077,40.077,0,0,1-7.44,0A40.074,40.074,0,0,1,306.69,207.963Z",
    transform: "translate(-235.841 -94.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14881",
    "data-name": "Path 14881",
    d: "M321.75,207.963a40.077,40.077,0,0,1-7.44,0A40.074,40.074,0,0,1,321.75,207.963Z",
    transform: "translate(-240.879 -94.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14887",
    "data-name": "Path 14887",
    d: "M234.054,152.645a1.331,1.331,0,0,1-.366.04h-1.051l-3.867.06h-9.124a10.581,10.581,0,0,1-1.817-.08,5.517,5.517,0,0,1-1.784-.666,5.324,5.324,0,0,1-2.356-2.822,5.177,5.177,0,0,1-.319-1.75v-1.657c0-2.15,0-4.093.04-5.737s.04-2.908.053-3.867a9.634,9.634,0,0,1,.033-1.051,1.592,1.592,0,0,1,.033-.366,1.224,1.224,0,0,1,0,.366c0,.28,0,.626.033,1.051,0,.958,0,2.269.06,3.867s0,3.587,0,5.737a9.349,9.349,0,0,0,.319,3.288,5.011,5.011,0,0,0,2.209,2.662,5.137,5.137,0,0,0,1.67.6,10.262,10.262,0,0,0,1.757.08h3.387l5.737.04,3.867.053,1.051.033A2.283,2.283,0,0,1,234.054,152.645Z",
    transform: "translate(-207.114 -70.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14888",
    "data-name": "Path 14888",
    d: "M355.85,119.09v49.041h52.182V119.09Z",
    transform: "translate(-254.774 -64.912)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14889",
    "data-name": "Path 14889",
    d: "M355.763,119.033h3.727l10.6-.04,37.854-.073h.153v49.187h0v.113H355.59v-.146c.033-14.747.06-27.026.08-35.617,0-4.272,0-7.633.04-9.936v.093c0,2.309,0,5.683.04,9.982,0,8.572.04,20.817.073,35.524l-.146-.146h52.182l-.173.173h0V119.113l.153.153-37.754-.08h-14.2Z",
    transform: "translate(-254.687 -64.855)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14890",
    "data-name": "Path 14890",
    d: "M386.605,127.44a16.105,16.105,0,1,0,16.105,16.105A16.105,16.105,0,0,0,386.605,127.44Zm.246,25.748a9.889,9.889,0,1,1,9.889-9.889,9.889,9.889,0,0,1-9.889,9.889Z",
    transform: "translate(-259.675 -67.705)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14891",
    "data-name": "Path 14891",
    d: "M376.959,143.934a9.889,9.889,0,0,1,5.85-9.031l-2.476-5.564a16.105,16.105,0,0,0-9.843,14.841v.665h6.475Q376.959,144.42,376.959,143.934Z",
    transform: "translate(-259.671 -68.34)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14892",
    "data-name": "Path 14892",
    d: "M401.34,181.863c0,.08-5.989.146-13.31.146s-13.31-.067-13.31-.146,5.989-.153,13.31-.153S401.34,181.777,401.34,181.863Z",
    transform: "translate(-261.086 -85.858)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14893",
    "data-name": "Path 14893",
    d: "M398.381,185.533c0,.087-3.328.153-7.394.153s-7.387-.067-7.387-.153,3.327-.153,7.387-.153S398.381,185.447,398.381,185.533Z",
    transform: "translate(-264.057 -87.086)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14894",
    "data-name": "Path 14894",
    d: "M391.445,148.14v.665l-1.331,3.055h-1.145l1.251-2.882h-.978v.572h-.892v-1.4Z",
    transform: "translate(-265.646 -74.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14895",
    "data-name": "Path 14895",
    d: "M396.175,150.656c0,.665-.5,1.271-1.617,1.271a2.8,2.8,0,0,1-1.437-.366l.373-.792a1.924,1.924,0,0,0,1.032.306c.353,0,.592-.14.592-.393s-.153-.373-.719-.373h-1l.18-2.17h2.369v.812h-1.5l-.047.539h.246C395.742,149.491,396.175,150,396.175,150.656Z",
    transform: "translate(-267.241 -74.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14896",
    "data-name": "Path 14896",
    d: "M398,149.118a.952.952,0,1,1,.952,1.032.938.938,0,0,1-.952-1.032Zm3.148-.978h.759l-2.576,3.713H398.6Zm-1.883.978c0-.373-.133-.519-.313-.519s-.313.146-.313.519.14.526.313.526.3-.146.3-.526Zm1.331,1.75a.925.925,0,0,1,.945-1.025,1.032,1.032,0,1,1-.945,1.025Zm1.258,0c0-.373-.133-.526-.313-.526s-.313.153-.313.526.14.526.313.526.326-.146.326-.526Z",
    transform: "translate(-268.871 -74.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14897",
    "data-name": "Path 14897",
    d: "M257.12,37.85V93.339h59.05V37.85Z",
    transform: "translate(-221.749 -37.737)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14898",
    "data-name": "Path 14898",
    d: "M257.026,37.793h4.226l11.979-.04,42.825-.073h.153V93.316h0v.173H256.84v-.153c0-16.691.053-30.58.073-40.3,0-4.838.033-8.651.04-11.24v.06c0,2.609,0,6.422.04,11.274,0,9.7.047,23.559.073,40.209l-.146-.146h59.05l-.173.173h0V37.88l.153.146-42.605-.133-12.032-.04h-4.286Z",
    transform: "translate(-221.655 -37.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14899",
    "data-name": "Path 14899",
    d: "M291.931,47.3a18.221,18.221,0,1,0,18.221,18.219A18.221,18.221,0,0,0,291.931,47.3Zm.273,29.135A11.194,11.194,0,1,1,303.4,65.242,11.194,11.194,0,0,1,292.2,76.435Z",
    transform: "translate(-227.298 -40.898)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14900",
    "data-name": "Path 14900",
    d: "M301.5,47.31v6.741a11.194,11.194,0,0,1,10.648,14.588l6.6,1.79A18.195,18.195,0,0,0,301.49,47.31Z",
    transform: "translate(-236.591 -40.901)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14901",
    "data-name": "Path 14901",
    d: "M281.027,65.958a11.18,11.18,0,0,1,6.654-10.221l-2.807-6.3A18.235,18.235,0,0,0,273.74,66.231V67h7.32C281.04,66.656,281.027,66.31,281.027,65.958Z",
    transform: "translate(-227.308 -41.614)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14902",
    "data-name": "Path 14902",
    d: "M299.71,87.16a11.473,11.473,0,0,1-2.329-.253c-.286,1.624-.819,4.772-1.231,7.247a18.208,18.208,0,0,0,20.863-13l-6.6-1.79a11.2,11.2,0,0,1-10.7,7.8Z",
    transform: "translate(-234.804 -51.622)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14903",
    "data-name": "Path 14903",
    d: "M308.594,108.913c0,.093-6.755.173-15.08.173s-15.074-.08-15.074-.173,6.748-.173,15.074-.173S308.594,108.787,308.594,108.913Z",
    transform: "translate(-228.88 -61.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14904",
    "data-name": "Path 14904",
    d: "M305.254,113.033c0,.093-3.747.173-8.365.173s-8.359-.08-8.359-.173,3.74-.173,8.359-.173S305.254,112.953,305.254,113.033Z",
    transform: "translate(-232.256 -62.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14905",
    "data-name": "Path 14905",
    d: "M297.681,73.829c0,.665-.5,1.238-1.617,1.238a2.855,2.855,0,0,1-1.444-.366l.386-.792a1.883,1.883,0,0,0,1.025.306c.359,0,.592-.133.592-.386s-.166-.359-.572-.359h-.439V72.8l.665-.712h-1.464V71.28h2.662v.665l-.765.825a1.065,1.065,0,0,1,.972,1.058Z",
    transform: "translate(-234.293 -48.919)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14906",
    "data-name": "Path 14906",
    d: "M302.465,73.8c0,.666-.5,1.271-1.617,1.271a2.782,2.782,0,0,1-1.437-.366l.373-.792a1.91,1.91,0,0,0,1.031.306c.353,0,.592-.14.592-.393s-.153-.373-.719-.373h-1.012l.186-2.17h2.363v.812h-1.491l-.047.539h.246C302.052,72.631,302.465,73.143,302.465,73.8Z",
    transform: "translate(-235.895 -48.919)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14907",
    "data-name": "Path 14907",
    d: "M304.3,72.258a.952.952,0,1,1,.952,1.032.938.938,0,0,1-.952-1.032Zm3.128-.978h.765l-2.536,3.713H304.9Zm-1.877.978c0-.373-.133-.526-.313-.526s-.313.153-.313.526.14.526.313.526.326-.146.326-.526Zm1.331,1.75a.925.925,0,0,1,.945-1.025,1.032,1.032,0,1,1-.945,1.025Zm1.258,0c0-.373-.14-.526-.313-.526s-.313.153-.313.526.14.526.313.526.353-.113.353-.526Z",
    transform: "translate(-237.528 -48.919)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "translate(14742.98 21018.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14962",
    "data-name": "Path 14962",
    d: "M99.1,412,81.07,426.794l18.288,22.534c2.043-1.877-3.095-17.043-3.095-17.043l11.946-9Z",
    transform: "translate(-72.139 -191.173)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5140",
    "data-name": "Group 5140",
    transform: "translate(17.66 233.142)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14963",
    "data-name": "Path 14963",
    d: "M95.972,430.708a1.191,1.191,0,0,0-1.571.213,1.145,1.145,0,0,0,.206,1.557,1.251,1.251,0,0,0,1.657-.24,1.185,1.185,0,0,0-.393-1.591",
    transform: "translate(-94.185 -430.504)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5141",
    "data-name": "Group 5141",
    transform: "translate(8.998 234.051)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14964",
    "data-name": "Path 14964",
    d: "M81.17,433.374l1.817-1.5,16.757,22.341s.373,1.331-.433,1.817Z",
    transform: "translate(-81.17 -431.87)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14965",
    "data-name": "Path 14965",
    d: "M103.044,442.243c-.113.087-.612-.426-1.4-.665s-1.491-.166-1.531-.306.732-.486,1.684-.16S103.164,442.183,103.044,442.243Z",
    transform: "translate(-78.507 -200.865)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14966",
    "data-name": "Path 14966",
    d: "M104.486,447.272c-.087.113-.665-.213-1.431-.206s-1.331.293-1.431.18.479-.665,1.437-.665S104.593,447.186,104.486,447.272Z",
    transform: "translate(-79.01 -202.74)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14967",
    "data-name": "Path 14967",
    d: "M103.312,452.608c-.106-.08.319-.665,1.151-.885s1.491.113,1.437.233-.665.06-1.331.24S103.412,452.708,103.312,452.608Z",
    transform: "translate(-79.573 -204.436)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14968",
    "data-name": "Path 14968",
    d: "M107.245,438.2c-.14.033-.4-.592-.945-1.178s-1.138-.918-1.091-1.052.819,0,1.457.719S107.372,438.183,107.245,438.2Z",
    transform: "translate(-80.212 -199.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14969",
    "data-name": "Path 14969",
    d: "M110.77,432.948c-.047.04-.466-.339-.912-1.131a6.954,6.954,0,0,1-.779-2.4,1.924,1.924,0,0,1,0-.559.612.612,0,0,1,.539-.526.8.8,0,0,1,.666.28,2.182,2.182,0,0,1,.286.472,5.641,5.641,0,0,1,.326.9,4.957,4.957,0,0,1,.16,1.591,2.449,2.449,0,0,1-.373,1.411c-.08,0,.06-.552,0-1.411a5.8,5.8,0,0,0-.246-1.464,5.59,5.59,0,0,0-.326-.812c-.133-.293-.3-.492-.453-.473s-.08,0-.106.126a1.744,1.744,0,0,0,0,.413,8.5,8.5,0,0,0,.146.872,8.212,8.212,0,0,0,.466,1.431A10.131,10.131,0,0,1,110.77,432.948Z",
    transform: "translate(-81.501 -196.634)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14970",
    "data-name": "Path 14970",
    d: "M111.216,434.067c-.053,0,.166-.566.845-1.185a4.745,4.745,0,0,1,1.364-.845,5.12,5.12,0,0,1,.918-.273,1.2,1.2,0,0,1,1.151.26.665.665,0,0,1,.067.725,1.876,1.876,0,0,1-.319.453,3.135,3.135,0,0,1-.759.619,3.368,3.368,0,0,1-1.557.466,1.89,1.89,0,0,1-1.418-.359,12.64,12.64,0,0,0,1.384,0,3.42,3.42,0,0,0,1.331-.506,3.094,3.094,0,0,0,.665-.552c.206-.226.326-.473.233-.546a.825.825,0,0,0-.665-.093,4.661,4.661,0,0,0-.839.22,5.2,5.2,0,0,0-1.331.665C111.6,433.661,111.283,434.114,111.216,434.067Z",
    transform: "translate(-82.22 -197.767)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14971",
    "data-name": "Path 14971",
    d: "M95.89,430.137l.22,23.326,29.022-.126c-.18-2.768-15.22-8.272-15.22-8.272l.472-14.954Z",
    transform: "translate(-77.096 -197.231)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5142",
    "data-name": "Group 5142",
    transform: "translate(23.003 246.56)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14972",
    "data-name": "Path 14972",
    d: "M103.043,450.722a1.185,1.185,0,0,0-.812,1.331,1.138,1.138,0,0,0,1.331.819,1.245,1.245,0,0,0,.852-1.444,1.185,1.185,0,0,0-1.484-.7",
    transform: "translate(-102.214 -450.667)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5143",
    "data-name": "Group 5143",
    transform: "translate(19.007 253.783)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14973",
    "data-name": "Path 14973",
    d: "M96.21,463.876V461.52l27.951.945s1.291.566,1.138,1.477Z",
    transform: "translate(-96.21 -461.52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14974",
    "data-name": "Path 14974",
    d: "M116.334,452.3c0,.14-.712.206-1.4.666s-1.065,1.058-1.2,1,.08-.872.932-1.411S116.367,452.163,116.334,452.3Z",
    transform: "translate(-83.052 -204.609)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14975",
    "data-name": "Path 14975",
    d: "M121.285,454.2c0,.133-.586.379-1.058.978s-.619,1.238-.759,1.231-.233-.805.373-1.544S121.278,454.044,121.285,454.2Z",
    transform: "translate(-84.948 -205.266)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14976",
    "data-name": "Path 14976",
    d: "M124.778,458.46c-.133.033-.333-.665,0-1.451s1.025-1.091,1.085-.972-.346.532-.665,1.178S124.918,458.447,124.778,458.46Z",
    transform: "translate(-86.698 -205.895)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14977",
    "data-name": "Path 14977",
    d: "M115.745,446.982c-.06.126-.712-.067-1.511,0s-1.424.313-1.5.193.519-.632,1.464-.665S115.812,446.868,115.745,446.982Z",
    transform: "translate(-82.729 -202.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14978",
    "data-name": "Path 14978",
    d: "M113.977,440.882a2.755,2.755,0,0,1-1.457,0,6.608,6.608,0,0,1-1.524-.466,6.714,6.714,0,0,1-.832-.439,1.564,1.564,0,0,1-.439-.339.612.612,0,0,1-.073-.752.785.785,0,0,1,.619-.326,1.836,1.836,0,0,1,.546.073,4.519,4.519,0,0,1,.905.306,4.946,4.946,0,0,1,1.331.872c.665.626.912,1.151.865,1.178s-.4-.393-1.085-.905a5.736,5.736,0,0,0-1.331-.725,4.568,4.568,0,0,0-.839-.253c-.306-.08-.566-.08-.665.053s0,.073.033.166a1.589,1.589,0,0,0,.326.246,6.359,6.359,0,0,0,.765.433,7.556,7.556,0,0,0,1.411.532,9.982,9.982,0,0,1,1.444.346Z",
    transform: "translate(-81.667 -200.057)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14979",
    "data-name": "Path 14979",
    d: "M115.722,440.032a2.3,2.3,0,0,1-.386-1.4,4.705,4.705,0,0,1,.186-1.6,5.73,5.73,0,0,1,.366-.878,1.211,1.211,0,0,1,.925-.739.666.666,0,0,1,.612.4,2.436,2.436,0,0,1,.153.532,3.214,3.214,0,0,1,0,.978,3.327,3.327,0,0,1-.612,1.5c-.566.759-1.158.932-1.165.878a5.863,5.863,0,0,0,.872-1.071,3.328,3.328,0,0,0,.459-1.364,2.975,2.975,0,0,0-.027-.805c-.047-.313-.166-.559-.28-.526a1.08,1.08,0,0,0-.506.479,5.146,5.146,0,0,0-.359.785,5.324,5.324,0,0,0-.273,1.457C115.649,439.486,115.776,440.012,115.722,440.032Z",
    transform: "translate(-83.598 -199.007)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14980",
    "data-name": "Path 14980",
    d: "M92.494,227.1a41.2,41.2,0,0,0-6.069,8.532c-2,4.179-3.274,14.129-3.274,14.129s-5.617,12.511-4.765,18.913,6.575,50.2,6.575,50.2-.28,42.525,3.787,50.112l.905,4.1,16.365-2.908h0l-.106-2.456,3.847-83.453,9.849-56.8Z",
    transform: "translate(-71.211 -129.323)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14981",
    "data-name": "Path 14981",
    d: "M135.275,239.856s9.783,53.852,10.648,63.222-32.436,58.637-32.436,58.637L98.26,345.837l21.855-40.6L113.007,264.3l9.883-36.17,10.382.359Z",
    transform: "translate(-77.889 -129.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14982",
    "data-name": "Path 14982",
    d: "M90.16,371.322a10.436,10.436,0,0,0,.12,1.185c.1.785.293,1.93.559,3.414.546,2.961,1.431,7.261,2.615,12.644v.113h.113l16.371-2.868h.126v-.126c.459-11.227,1-24.623,1.584-39.045.606-15.486,1.165-29.848,1.624-41.627h0c1.225-9.463,2.243-17.3,2.948-22.767.346-2.722.612-4.858.8-6.336l.2-1.657c.04-.379.053-.572.053-.572s-.047.186-.1.566-.14.938-.246,1.657c-.2,1.471-.5,3.6-.878,6.316-.739,5.47-1.8,13.31-3.081,22.753h0c-.479,11.779-1.058,26.141-1.69,41.627-.559,14.395-1.085,27.818-1.524,39.051l.133-.153-16.358,2.942.14.093c-1.218-5.324-2.136-9.65-2.722-12.6-.286-1.477-.5-2.615-.619-3.394-.073-.386-.106-.665-.133-.878a2.661,2.661,0,0,0-.033-.333Z",
    transform: "translate(-75.179 -144.904)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14983",
    "data-name": "Path 14983",
    d: "M116.2,87.114c.486-2.855-1.69-5.73-4.452-6.6a9.757,9.757,0,0,0-8.232,1.637c-1.764,1.231-3.228,2.888-5.1,3.96-1.7.972-3.674,1.418-5.324,2.429a9.277,9.277,0,0,0-4.419,7.627c-.04,2.13.665,4.4-.313,6.3-1.038,2.076-3.654,2.928-4.838,4.925-1.071,1.8-.719,4.093-.206,6.129s1.151,4.186.559,6.2c-.546,1.83-2,3.234-2.848,4.965a7.786,7.786,0,0,0,3.2,9.829l17.576-7.134Z",
    transform: "translate(-71.909 -80.177)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14984",
    "data-name": "Path 14984",
    d: "M130.73,88.632c2.709-.26,5.164,1.89,6.216,4.4s1.018,5.324,1.058,8.039.2,5.557,1.551,7.913c.712,1.238,1.724,2.276,2.542,3.447a5.883,5.883,0,0,1,1.271,3.993c-.326,2.575-3.154,4.159-3.867,6.655-.579,2,.353,4.219-.113,6.269A6.3,6.3,0,0,1,136.5,133.1a16.777,16.777,0,0,1-4.492,1.79l-8.818-6.821,2.143-39.99Z",
    transform: "translate(-86.228 -82.821)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14985",
    "data-name": "Path 14985",
    d: "M105.4,102.2l1.051,28.4a8.445,8.445,0,0,0,9.171,8.1h0a8.172,8.172,0,0,0,7.447-8.651c-.08-2.13-.033-4.658,0-4.878,0,0,7.108-1.6,7.36-8.765.126-3.467.047-9.317-.326-15.759A13.357,13.357,0,0,0,117.04,88h-.666C108.881,88.246,104.928,94.735,105.4,102.2Z",
    transform: "translate(-80.265 -82.794)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14986",
    "data-name": "Path 14986",
    d: "M127.317,142.365A16.7,16.7,0,0,1,118,139.49s2.09,5.211,9.257,4.732Z",
    transform: "translate(-84.492 -100.018)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14987",
    "data-name": "Path 14987",
    d: "M138.883,115.994a1.032,1.032,0,0,1-1.012,1.012.978.978,0,0,1-1.032-.952,1.018,1.018,0,0,1,1.012-1,.978.978,0,0,1,1.032.945Z",
    transform: "translate(-90.794 -91.842)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14988",
    "data-name": "Path 14988",
    d: "M138.087,112.274c-.133.133-.892-.459-2-.486s-1.923.512-2.036.373.08-.3.433-.546a2.815,2.815,0,0,1,1.637-.466,2.709,2.709,0,0,1,1.584.552C138.04,111.975,138.153,112.214,138.087,112.274Z",
    transform: "translate(-89.851 -90.537)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14989",
    "data-name": "Path 14989",
    d: "M123.183,115.994a1.031,1.031,0,0,1-1.012,1.012.978.978,0,0,1-1.032-.952,1.018,1.018,0,0,1,1.012-1,.972.972,0,0,1,1.032.945Z",
    transform: "translate(-85.542 -91.841)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14990",
    "data-name": "Path 14990",
    d: "M122.256,112.507c-.133.133-.892-.459-2-.479s-1.923.506-2.036.366.073-.293.433-.546a2.815,2.815,0,0,1,1.637-.459,2.709,2.709,0,0,1,1.584.552C122.21,112.208,122.316,112.461,122.256,112.507Z",
    transform: "translate(-84.555 -90.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14991",
    "data-name": "Path 14991",
    d: "M129.339,119.87a7.846,7.846,0,0,1,1.8-.279c.286,0,.552-.073.606-.26a1.431,1.431,0,0,0-.173-.839c-.246-.666-.506-1.411-.779-2.163a36.378,36.378,0,0,1-1.737-5.65,36.3,36.3,0,0,1,2.189,5.5c.26.759.506,1.484.745,2.17a1.637,1.637,0,0,1,.12,1.111.719.719,0,0,1-.473.4,1.6,1.6,0,0,1-.479.053,6.655,6.655,0,0,1-1.817-.04Z",
    transform: "translate(-88.185 -90.38)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14992",
    "data-name": "Path 14992",
    d: "M121.251,106.136c-.126.293-1.218.093-2.516.186s-2.363.386-2.522.113c-.067-.133.126-.406.566-.665a3.174,3.174,0,0,1,2-.5,3.793,3.793,0,0,1,1.837.273C121.078,105.75,121.3,106,121.251,106.136Z",
    transform: "translate(-83.89 -88.565)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14993",
    "data-name": "Path 14993",
    d: "M138.575,105.923c-.226.253-1.111,0-2.183-.047s-2,.146-2.176-.113c-.093-.126.053-.379.453-.612a3.594,3.594,0,0,1,3.514.133C138.555,105.544,138.675,105.8,138.575,105.923Z",
    transform: "translate(-89.907 -88.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14994",
    "data-name": "Path 14994",
    d: "M128.267,129.07a2.436,2.436,0,0,0-.226-.665,1.564,1.564,0,0,0-1.258-.765,2,2,0,0,0-1.411.5,1.61,1.61,0,0,0-.552,1.185.885.885,0,0,0,.087.346,2.1,2.1,0,0,0,1.477,1.231,1.737,1.737,0,0,0,1.75-.705,1.191,1.191,0,0,0,.206-.532,2,2,0,0,0-.073-.592Z",
    transform: "translate(-86.773 -96.053)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14995",
    "data-name": "Path 14995",
    d: "M107.046,123.706c-.04,0-.093,0-.087.073a.073.073,0,0,0,.106.047.08.08,0,0,0,0-.12.067.067,0,0,0-.06,0",
    transform: "translate(-80.798 -94.736)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14996",
    "data-name": "Path 14996",
    d: "M107.206,123.246a.066.066,0,1,0,.013.12.073.073,0,0,0,0-.12.06.06,0,0,0-.06,0",
    transform: "translate(-80.852 -94.581)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14997",
    "data-name": "Path 14997",
    d: "M129.129,129.333c0,.08-.28.24-.805.319a3.54,3.54,0,0,1-2.09-.306,3.141,3.141,0,0,1-1.484-1.524c-.226-.492-.233-.832-.153-.865.2-.093.665,1.145,1.943,1.77a5.057,5.057,0,0,0,1.764.439C128.8,129.214,129.115,129.227,129.129,129.333Z",
    transform: "translate(-86.683 -95.824)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14998",
    "data-name": "Path 14998",
    d: "M100.968,107.083c-1.637-5.783-.805-12.4,2.888-17.143s10.388-7.187,16.072-5.231a5.45,5.45,0,0,1,2.183,1.264,2.489,2.489,0,0,1,.665,2.336c-.386,1.284-1.93,1.79-3.268,1.85s-2.768-.106-3.92.572c-2.036,1.191-2,4.186-3.434,6.049-.712.918-1.77,1.537-2.416,2.5-1.744,2.609-.306,4.173-1.418,7.108a3.763,3.763,0,0,1-2.589,1.677c-.865.12-.173.106-2-.1h0Z",
    transform: "translate(-78.527 -81.467)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14999",
    "data-name": "Path 14999",
    d: "M106.741,119.992c-.12-.06-4.812-1.7-4.911,3.168s4.812,3.993,4.825,3.827S106.741,119.992,106.741,119.992Z",
    transform: "translate(-79.082 -93.39)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15000",
    "data-name": "Path 15000",
    d: "M105.816,125.882a1.334,1.334,0,0,1-.233.12.792.792,0,0,1-.665,0,2.089,2.089,0,0,1-.932-1.9,2.715,2.715,0,0,1,.26-1.2.992.992,0,0,1,.665-.666.439.439,0,0,1,.5.24c.06.14,0,.233.053.246s.106-.08.073-.286a.546.546,0,0,0-.186-.306.665.665,0,0,0-.466-.133,1.2,1.2,0,0,0-.905.739,2.855,2.855,0,0,0-.319,1.331,2.192,2.192,0,0,0,1.191,2.13.938.938,0,0,0,.779-.113C105.8,125.988,105.829,125.895,105.816,125.882Z",
    transform: "translate(-79.695 -94.162)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15001",
    "data-name": "Path 15001",
    d: "M93.05,101.625a9.477,9.477,0,0,0,3.294.765,10.575,10.575,0,0,0,3.6-.559,16.637,16.637,0,0,0,3.993-2.056c1.331-.9,2.516-1.863,3.614-2.729s2.1-1.637,2.981-2.223a17.3,17.3,0,0,1,2.176-1.264,3.641,3.641,0,0,1,.858-.339s-.286.166-.8.459a23.129,23.129,0,0,0-2.1,1.331c-.859.606-1.843,1.384-2.922,2.269s-2.276,1.863-3.62,2.775a16.278,16.278,0,0,1-4.086,2.063,10.422,10.422,0,0,1-3.707.506,7.693,7.693,0,0,1-2.469-.539,4.658,4.658,0,0,1-.612-.306A.824.824,0,0,1,93.05,101.625Z",
    transform: "translate(-76.146 -84.54)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15002",
    "data-name": "Path 15002",
    d: "M92.48,106.538c0-.047.665.359,1.83.885a21.561,21.561,0,0,0,4.619,1.537,21.3,21.3,0,0,0,4.851.433c1.251,0,2-.133,2.03-.073a1.824,1.824,0,0,1-.532.133,11.8,11.8,0,0,1-1.484.186,18.161,18.161,0,0,1-9.59-2,11.391,11.391,0,0,1-1.291-.765C92.619,106.678,92.466,106.558,92.48,106.538Z",
    transform: "translate(-75.955 -88.994)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15003",
    "data-name": "Path 15003",
    d: "M143.414,100.575a4.725,4.725,0,0,1-3.654-3.095,21.208,21.208,0,0,0,1.63,1.784A20.957,20.957,0,0,0,143.414,100.575Z",
    transform: "translate(-91.77 -85.965)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15004",
    "data-name": "Path 15004",
    d: "M144.247,109.218c.053.073-.206.359-.665.512s-.832.087-.832,0,.333-.186.719-.319S144.161,109.138,144.247,109.218Z",
    transform: "translate(-92.771 -89.884)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15005",
    "data-name": "Path 15005",
    d: "M185.622,192.419a7.547,7.547,0,0,1,1.158-4.233c1.278-1.73,3.993-2.522,4.213-3.727s2.3-3.62,3.327-3.061,1.444,1.863,0,3.367a24.452,24.452,0,0,0-2.582,3.188s12.937-2.243,13.882-2.076,1.89.326,1.9,1.125-2.509,1.018-2.509,1.018l-4.213,2.928a17.969,17.969,0,0,1-3.4,3.514,12.092,12.092,0,0,1-4.725,1.677L188.191,199S183.772,195.787,185.622,192.419Z",
    transform: "translate(-106.96 -114.008)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15006",
    "data-name": "Path 15006",
    d: "M211.1,191.158a2.272,2.272,0,0,0-.226-.233,1.391,1.391,0,0,0-.759-.353,4.659,4.659,0,0,0-2.709.805,12.643,12.643,0,0,0-2.256,1.883,4.959,4.959,0,0,1-.905.845,4.732,4.732,0,0,1,.745-1,9.557,9.557,0,0,1,2.249-2,4.372,4.372,0,0,1,2.922-.752,1.371,1.371,0,0,1,.812.486C211.1,191.024,211.118,191.151,211.1,191.158Z",
    transform: "translate(-113.343 -117.026)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15007",
    "data-name": "Path 15007",
    d: "M205.753,191.8a12.611,12.611,0,0,1-3.953.852,13.13,13.13,0,0,1,3.953-.852Z",
    transform: "translate(-112.523 -117.515)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15008",
    "data-name": "Path 15008",
    d: "M197.71,192.729a3.008,3.008,0,0,1,2.988,2.176,10.748,10.748,0,0,0-1.331-1.331,9.982,9.982,0,0,0-1.657-.845Z",
    transform: "translate(-111.155 -117.826)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15009",
    "data-name": "Path 15009",
    d: "M148.35,154.92s6.355,3.234,7.9,7.493c.812,2.243,5.617,26.081,5.617,26.081l9.676-6.568,6.522,9.849-15.473,12.046a14.361,14.361,0,0,1-9.1-.665,3.85,3.85,0,0,1-2.1-1.517C150.779,199.928,148.35,154.92,148.35,154.92Z",
    transform: "translate(-94.644 -105.179)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5144",
    "data-name": "Group 5144",
    transform: "translate(61.955 83.276)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15010",
    "data-name": "Path 15010",
    d: "M161.913,209.29a5.973,5.973,0,0,0-.812,5.47.892.892,0,0,0,.293.419.719.719,0,0,0,.945-.306,2.362,2.362,0,0,0,.226-1.078,13.836,13.836,0,0,1,3.487-8.392v-.093A17.3,17.3,0,0,0,161.913,209.29Z",
    transform: "translate(-160.745 -205.31)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15011",
    "data-name": "Path 15011",
    d: "M80.244,156.7l18.361-5.956c3.567,9.483,15.054,7.866,15.639.233l10.908,2.6s3.654,23.153,2.768,27.951c-1.424,7.733,2.15,32.856,4.04,41.893,1.644,7.826-3.154,12.478-5.564,14.608-12.258,10.834-18.634,9.377-27.6,3.747a128.077,128.077,0,0,0-19.8-9.71c.892-10.482,6.7-21.356,10.435-29.222h0l-1.717-18.281Z",
    transform: "translate(-71.446 -103.781)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15012",
    "data-name": "Path 15012",
    d: "M154.337,228.742a3.146,3.146,0,0,1-.16-.539c-.087-.353-.22-.872-.373-1.551-.313-1.331-.725-3.327-1.145-5.763s-.832-5.377-1.145-8.651-.486-6.875-.539-10.648-.106-7.387-.359-10.648a56.569,56.569,0,0,0-1.211-8.6,35.653,35.653,0,0,0-1.724-5.59c-.24-.665-.492-1.125-.626-1.464a3.666,3.666,0,0,1-.206-.519,2.955,2.955,0,0,1,.273.492,14.94,14.94,0,0,1,.665,1.444,33.2,33.2,0,0,1,1.837,5.584,54.609,54.609,0,0,1,1.318,8.6c.266,3.274.333,6.888.386,10.648s.226,7.38.512,10.648.665,6.182,1.065,8.651.765,4.412,1.038,5.777c.133.665.233,1.178.313,1.564a4.511,4.511,0,0,1,.08.559Z",
    transform: "translate(-94.142 -111.819)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5145",
    "data-name": "Group 5145",
    transform: "translate(9.883 102.397)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15013",
    "data-name": "Path 15013",
    d: "M108,234.167c-3.86-.186-7.84-.353-11.453.992-5.51,2.043-9.2,7.174-14.042,10.515l.459.166a13.363,13.363,0,0,0,14.348-.892c2-1.511,3.607-3.627,5.95-4.519a20.44,20.44,0,0,0,3.088-1.085,4.179,4.179,0,0,0,1.65-5.178Z",
    transform: "translate(-82.5 -234.043)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15014",
    "data-name": "Path 15014",
    d: "M76.448,159.78a10.974,10.974,0,0,0-4.658,5.284c-1.251,3.021-4.658,43.763-4.073,46.372s3.327,6.515,7.826,8.545c3.8,1.71,13.623-2.436,17.609-3.9.126-.047-.892-1.577-1.331-2.6l-3.374-10.748-5.4.586,2-20.2Z",
    transform: "translate(-67.649 -106.805)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15015",
    "data-name": "Path 15015",
    d: "M89.89,180.36a7.921,7.921,0,0,1,.273,1.131c.146.739.319,1.81.492,3.141.346,2.662.666,6.355.965,10.428l.739,10.448c.106,1.291.2,2.356.266,3.161a7.129,7.129,0,0,1,.08,1.158,7.512,7.512,0,0,1-.213-1.145c-.113-.739-.24-1.817-.379-3.154-.266-2.662-.539-6.362-.839-10.442s-.579-7.766-.865-10.428c-.14-1.331-.273-2.4-.379-3.141A6.868,6.868,0,0,1,89.89,180.36Z",
    transform: "translate(-75.089 -113.689)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15016",
    "data-name": "Path 15016",
    d: "M91.506,223.73a12.833,12.833,0,0,1-1.757.366c-1.111.193-2.662.453-4.525.745h-.093a8.412,8.412,0,0,0-3.061-.732,8.312,8.312,0,0,0-3.587.632,8.571,8.571,0,0,0-2.5,1.63,13.976,13.976,0,0,0-1.75,2.163,2.662,2.662,0,0,1,.313-.665,8.073,8.073,0,0,1,1.264-1.65,8.512,8.512,0,0,1,2.556-1.744,8.292,8.292,0,0,1,3.72-.665,8.512,8.512,0,0,1,3.188.779h-.093c1.843-.266,3.421-.479,4.545-.619A11.029,11.029,0,0,1,91.506,223.73Z",
    transform: "translate(-69.85 -128.196)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15017",
    "data-name": "Path 15017",
    d: "M95.737,240.53a2.928,2.928,0,0,1,.406.665l1.018,1.823.067.113-.126.053c-1.837.712-4.545,1.73-7.567,2.842l-2.615.958-.093-.319h0l.087.319h-.067l-.08-.326H86.8l.093.319a12.3,12.3,0,0,1-5.743.512,12.863,12.863,0,0,1-1.637-.359,2.482,2.482,0,0,1-.572-.213c0-.053.832.2,2.236.359a12.711,12.711,0,0,0,5.61-.619l.093.319h0l-.08-.326h.06l.087.319h0l-.1-.326,2.609-.965c3.021-1.111,5.743-2.09,7.607-2.735l-.067.16-.925-1.87a3.76,3.76,0,0,1-.333-.705Z",
    transform: "translate(-71.426 -133.816)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15018",
    "data-name": "Path 15018",
    d: "M167.3,205.2a26.717,26.717,0,0,0-1.863,2.436c-.852,1.451-1.178,2.815-1.291,2.782a6.3,6.3,0,0,1,.992-2.961A5.657,5.657,0,0,1,167.3,205.2Z",
    transform: "translate(-99.929 -121.998)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15019",
    "data-name": "Path 15019",
    d: "M135.12,93.84a1.027,1.027,0,0,1,0,.14h0Z",
    transform: "translate(-90.218 -84.747)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15020",
    "data-name": "Path 15020",
    d: "M114.734,234.208a10.981,10.981,0,0,1-.819-3.387,10.828,10.828,0,0,1-.087-3.481,27.215,27.215,0,0,1,.479,3.427A22.626,22.626,0,0,1,114.734,234.208Z",
    transform: "translate(-83.063 -129.404)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15021",
    "data-name": "Path 15021",
    d: "M97.381,130.65,81.05,147.407a11.886,11.886,0,0,1,.313,11.7L95,159.546l.08-3.674a4.758,4.758,0,0,0,3.254,3.214c2.07.592,4.279.04,6.355-.539a128.388,128.388,0,0,1-7.307-27.9Z",
    transform: "translate(-72.132 -97.061)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15022",
    "data-name": "Path 15022",
    d: "M111.033,183.41c0,.492-.093,30.347-.093,30.347l25.289.845,1.264-30.2Z",
    transform: "translate(-82.13 -114.709)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15023",
    "data-name": "Path 15023",
    d: "M113.237,180.053c0,.612-3.507,36.343-3.507,36.343l27.458-.665,4.619-35.691Z",
    transform: "translate(-81.725 -113.582)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15024",
    "data-name": "Path 15024",
    d: "M141.91,190.8c0,.1-4.712.173-10.515.173s-10.515-.073-10.515-.173,4.712-.173,10.515-.173S141.91,190.71,141.91,190.8Z",
    transform: "translate(-85.455 -117.124)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15025",
    "data-name": "Path 15025",
    d: "M141.513,194.343c0,.093-4.705.173-10.508.173s-10.515-.08-10.515-.173,4.705-.173,10.515-.173S141.513,194.243,141.513,194.343Z",
    transform: "translate(-85.325 -118.308)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15026",
    "data-name": "Path 15026",
    d: "M140.81,198.813c0,.1-4.712.173-10.515.173s-10.515-.073-10.515-.173,4.712-.173,10.515-.173S140.81,198.72,140.81,198.813Z",
    transform: "translate(-85.087 -119.803)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15027",
    "data-name": "Path 15027",
    d: "M140.06,202.82c0,.093-4.712.173-10.515.173s-10.515-.08-10.515-.173,4.712-.18,10.515-.18S140.06,202.72,140.06,202.82Z",
    transform: "translate(-84.836 -121.141)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15028",
    "data-name": "Path 15028",
    d: "M140.06,206.823c0,.093-4.712.173-10.515.173s-10.515-.08-10.515-.173,4.712-.173,10.515-.173S140.06,206.73,140.06,206.823Z",
    transform: "translate(-84.836 -122.483)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15029",
    "data-name": "Path 15029",
    d: "M139.683,211.023c0,.1-4.705.173-10.515.173s-10.508-.073-10.508-.173,4.705-.173,10.508-.173S139.683,210.95,139.683,211.023Z",
    transform: "translate(-84.712 -123.888)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15030",
    "data-name": "Path 15030",
    d: "M139.3,215.223c0,.1-4.705.18-10.508.18s-10.515-.08-10.515-.18,4.705-.173,10.515-.173S139.3,215.13,139.3,215.223Z",
    transform: "translate(-84.585 -125.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15031",
    "data-name": "Path 15031",
    d: "M138.923,219.433c0,.093-4.705.173-10.508.173s-10.515-.08-10.515-.173,4.705-.173,10.515-.173S138.923,219.333,138.923,219.433Z",
    transform: "translate(-84.458 -126.701)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15032",
    "data-name": "Path 15032",
    d: "M138.55,223.633c0,.093-4.712.173-10.515.173s-10.515-.08-10.515-.173,4.712-.173,10.515-.173S138.55,223.54,138.55,223.633Z",
    transform: "translate(-84.331 -128.106)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15033",
    "data-name": "Path 15033",
    d: "M138.173,227.833c0,.1-4.705.173-10.515.173s-10.508-.073-10.508-.173,4.705-.173,10.508-.173S138.173,227.74,138.173,227.833Z",
    transform: "translate(-84.207 -129.511)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15034",
    "data-name": "Path 15034",
    d: "M97.525,225.769s2.189-4.832,2.662-5.1a85.452,85.452,0,0,1,9.836-1.185c1.684,0,4.279.047,4.712.872.319.606,0,1.5-1.251,1.684,0,0,1.744-.093,1.557,1s-4.106,3.095-4.106,3.095.732.825-.725,2.369l-.665.819s.273,1.457-.546,2.1a49.249,49.249,0,0,1-6.009,2.456l-2-.632-1.271.632S95.562,229.809,97.525,225.769Z",
    transform: "translate(-77.467 -126.774)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15035",
    "data-name": "Path 15035",
    d: "M116.485,223a9.031,9.031,0,0,1-1.744.619c-1.1.333-2.622.745-4.326,1.118s-3.261.665-4.392.812a9,9,0,0,1-1.843.173,10.49,10.49,0,0,1,1.8-.419c1.118-.22,2.662-.526,4.359-.905s3.221-.745,4.332-1.012A10.647,10.647,0,0,1,116.485,223Z",
    transform: "translate(-79.869 -127.952)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15036",
    "data-name": "Path 15036",
    d: "M113.91,229.685a17.128,17.128,0,0,1-7.5,1.624c0-.1,1.7-.273,3.767-.725S113.87,229.592,113.91,229.685Z",
    transform: "translate(-80.615 -130.184)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15037",
    "data-name": "Path 15037",
    d: "M113.178,234.2a5.643,5.643,0,0,1-2.4,1.291,5.743,5.743,0,0,1-2.7.359c0-.1,1.2-.226,2.6-.665S113.124,234.109,113.178,234.2Z",
    transform: "translate(-81.173 -131.694)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15038",
    "data-name": "Path 15038",
    d: "M102.645,234.327a1.421,1.421,0,0,1-.918-.306,2.243,2.243,0,0,1-.665-.832,2.276,2.276,0,0,1-.186-1.291.945.945,0,0,0-.093-.532,2.915,2.915,0,0,0-.366-.426,1.8,1.8,0,0,1-.453-.985c-.073-.626.166-.965.193-.945a4.817,4.817,0,0,0,.047.905,1.75,1.75,0,0,0,.446.805,3.082,3.082,0,0,1,.426.473,1.211,1.211,0,0,1,.146.719,2.1,2.1,0,0,0,.665,1.917A3.708,3.708,0,0,0,102.645,234.327Z",
    transform: "translate(-78.454 -129.962)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15039",
    "data-name": "Path 15039",
    d: "M105.352,239.56c0,.1-.579.08-.992-.433s-.306-1.085-.213-1.058.153.446.486.839S105.352,239.467,105.352,239.56Z",
    transform: "translate(-79.829 -132.992)",
    fill: "#c4c4c4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.3998bc44207167c3fe8b6ecd748c8672.svg";
export { ForwardRef as ReactComponent };